import React from 'react';
import { Col, Button } from 'antd';
import PropTypes from 'prop-types';

export default function FormActionButton(props) {
  const {
    goBack,
    handleSubmit, loadingButton,
    handleSubmitClose, loadingButtonClose,
    handleDelete, loadingButtonDelete,
    handleRedirectEdit
  } = props;
  return (
    <Col className="footer-form" span={24}>
      {goBack && (
        <Button
          icon="left"
          onClick={goBack}
        >
          Quay lại
        </Button>
      )}
      {handleSubmit && (
        <Button
          icon="save"
          loading={loadingButton}
          onClick={handleSubmit}
          type="primary submit"
        >
          Lưu
        </Button>
      )}
      {handleSubmitClose && (
        <Button
          icon="export"
          loading={loadingButtonClose}
          onClick={handleSubmitClose}
          type="primary submit"
        >
          Lưu và đóng
        </Button>
      )}
      {handleRedirectEdit && (
        <Button
          icon="edit"
          onClick={handleRedirectEdit}
          style={{ background: 'green', color: '#fff' }}
        >
          Chỉnh sửa
        </Button>
      )}
      {handleDelete && (
        <Button
          icon="delete"
          loading={loadingButtonDelete}
          onClick={handleDelete}
          type="danger submit"
        >
          Xóa
        </Button>
      )}
    </Col>
  );
}

FormActionButton.propTypes = {
  handleSubmit: PropTypes.func,
  goBack: PropTypes.func,
  handleSubmitClose: PropTypes.func,
  handleDelete: PropTypes.func,
  handleRedirectEdit: PropTypes.func,
  loadingButton: PropTypes.bool,
  loadingButtonClose: PropTypes.bool,
  loadingButtonDelete: PropTypes.bool
};

FormActionButton.defaultProps = {
  handleSubmit: null,
  goBack: null,
  handleSubmitClose: null,
  handleRedirectEdit: null,
  handleDelete: null,
  loadingButton: false,
  loadingButtonClose: false,
  loadingButtonDelete: false
};
